import { ColumnData } from 'tiime-material';

export enum ColumnNames {
  source = 'source',
  archived = 'archived',
  company = 'company',
  businessUnit = 'businessUnit',
  brand = 'brand',
  startDate = 'startDate',
  status = 'status',
  contact = 'contact',
  owner = 'owner',
  internalComment = 'internalComment',
  createdAt = 'createdAt',
  reminders = 'reminders',
  actions = 'actions'
}

export const defaultFilterColumns: ColumnData[] = [
  { code: ColumnNames.company, label: 'Opportunité', hidden: false, disabled: false },
  { code: ColumnNames.businessUnit, label: 'Groupe', hidden: false, disabled: false },
  { code: ColumnNames.brand, label: 'Marque', hidden: false, disabled: false },
  { code: ColumnNames.startDate, label: 'Date de début', hidden: false, disabled: false },
  { code: ColumnNames.status, label: 'État', hidden: false, disabled: false },
  { code: ColumnNames.contact, label: 'Contact', hidden: false, disabled: false },
  { code: ColumnNames.createdAt, label: 'Créé le', hidden: false, disabled: false },
  { code: ColumnNames.owner, label: 'Référent commercial', hidden: false, disabled: false },
  { code: ColumnNames.internalComment, label: 'Note interne', hidden: false, disabled: false },
  { code: ColumnNames.reminders, label: 'Relances', hidden: false, disabled: false }
];

export const defaultDisplayedColumns = [
  ColumnNames.company,
  ColumnNames.businessUnit,
  ColumnNames.brand,
  ColumnNames.startDate,
  ColumnNames.status,
  ColumnNames.contact,
  ColumnNames.createdAt,
  ColumnNames.owner,
  ColumnNames.archived,
  ColumnNames.internalComment,
  ColumnNames.reminders,
  ColumnNames.actions
];

export const columnsKey = 'contracts_columns';
